import React from 'react'
import { FiPlus } from 'react-icons/fi'
import { Link } from 'react-router-dom';

const Loan_SchemesHeader = () => {
    return (
        <>
            <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">

                <Link to="/loan/add-loan-schemes" className="btn btn-primary">
                    <FiPlus size={16} className='me-2' />
                    <span>Create Loan Schemes</span>
                </Link>
            </div>

        </>
    )
}

export default Loan_SchemesHeader